import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="bg-white max-w-4xl mx-auto p-8 shadow-sm">
      <h1 className="text-2xl font-bold mb-6">Politique de confidentialité</h1>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
        <p className="mb-3 text-gray-700">
          Bienvenue sur Elille Academy. Les présentes Conditions Générales régissent votre utilisation de notre 
          site web et de nos services. En accédant à notre plateforme ou en l'utilisant, vous acceptez d'être lié 
          par ces Conditions. Si vous n'êtes pas d'accord avec une partie de ces conditions, vous ne pouvez pas 
          accéder à nos services.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. Utilisation des Services</h2>
        <p className="mb-3 text-gray-700">
          Notre plateforme propose du contenu éducatif lié à la formation aux droits humains. Vous pouvez accéder 
          et utiliser nos services à des fins personnelles et non commerciales. Vous vous engagez à ne pas faire un 
          usage abusif de nos services et à ne pas aider quelqu'un d'autre à le faire.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">3. Comptes Utilisateurs</h2>
        <p className="mb-3 text-gray-700">
          Lorsque vous créez un compte chez nous, vous devez fournir des informations exactes et complètes. Vous êtes 
          responsable de la protection de votre mot de passe et de toutes les activités qui se déroulent sous votre 
          compte. Vous devez nous informer immédiatement de toute utilisation non autorisée de votre compte.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">4. Contenu des Formations</h2>
        <p className="mb-3 text-gray-700">
          Tous les matériels de formation, y compris les vidéos, les documents et autres ressources, sont fournis 
          uniquement à des fins éducatives. Le contenu est protégé par le droit d'auteur et d'autres droits de 
          propriété intellectuelle. Vous ne pouvez pas distribuer, modifier ou reproduire tout contenu sans notre 
          autorisation écrite.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">5. Politique de Confidentialité</h2>
        <p className="mb-3 text-gray-700">
          Votre utilisation de nos services est également régie par notre Politique de Confidentialité, qui décrit 
          comment nous collectons, utilisons et protégeons vos informations personnelles. En utilisant nos services, 
          vous consentez également aux termes de notre Politique de Confidentialité.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">6. Limitation de Responsabilité</h2>
        <p className="mb-3 text-gray-700">
          Dans toute la mesure permise par la loi, nous ne serons pas responsables des dommages indirects, accessoires, 
          spéciaux, consécutifs ou punitifs résultant de votre accès à ou de l'utilisation de, ou de l'impossibilité 
          d'accéder à ou d'utiliser, nos services.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">7. Modifications des Conditions</h2>
        <p className="mb-3 text-gray-700">
          Nous nous réservons le droit de modifier ces conditions à tout moment. Nous informerons des changements 
          significatifs en publiant une annonce sur notre plateforme. Votre utilisation continue de nos services 
          après de telles modifications constitue votre acceptation des conditions mises à jour.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">8. Loi Applicable</h2>
        <p className="mb-3 text-gray-700">
          Les présentes Conditions sont régies et interprétées conformément aux lois du Maroc, sans égard à ses 
          dispositions en matière de conflit de lois.
        </p>
      </section>
      
      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-3">9. Nous Contacter</h2>
        <p className="text-gray-700">
          Si vous avez des questions concernant ces Conditions, veuillez nous contacter à l'adresse 
          support@elilleacademy.com.
        </p>
      </section>
      
      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-sm text-gray-500 text-center">
          Dernière mise à jour : 10 mai 2025
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;